import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';

export type customChangeOE_ModalProps = {
  showChangeOE_Modal: boolean;
  handleCloseChangeOE_Modal: () => void;
};
 
const ChangeOE_Modal = ({
  showChangeOE_Modal,
  handleCloseChangeOE_Modal,
}: customChangeOE_ModalProps) => {
  return (
    <Modal
      show={showChangeOE_Modal}
      onHide={handleCloseChangeOE_Modal}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Changes to Know for OE</h4>
      </ModalHeader>
      <Modal.Body>
        <Container className="p-0">
          <Container
            className={'col-12 border-bottom pb-10'}
          >
          <Row>
          <Col className={'col-12 px-0 mt-2 lh-xs fw-light text-sub '}>  

          <ul>
            <li>Monthly premiums for Delta’s medical options are increasing by $2 - $15.</li>

            <li>The IRS is increasing HSA contribution limits to offset increased deductibles, allowing you to save more.</li>

            <li>Our prescription drug benefits will remain with CVS Caremark. PrudentRx, which offers savings on specialty drugs, will be expanded to the Gold and Silver HSA options in 2025 (previously only available with the Copay Option).</li>

            <li>While the dental option premiums remain unchanged, the Basic dental option will include full mouth X rays covered under preventive care and major restorative services such as crowns, bridges, inlays and onlays paid at 10%. The Comprehensive dental option will offer coverage for bone grafts paid at 50%.</li>

            <li>Vision coverage will include an annual frames allowance (instead of every 24 months) and monthly premiums will increase by $.57 - $1.67.</li>

            <li>The Delta-provided basic life benefit amount for pilots will increase to $1,140,000. Additional information is available on the OE HQ.</li>
            </ul>
            </Col>
           <Col className={'col-4 text-end px-0 mt-3'}>
 
            </Col>
            </Row>
          </Container>
          
          <div className={'d-none d-lg-block mt-10'}>
 
          </div>

        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseChangeOE_Modal}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeOE_Modal;

